import { apiClient } from "../config";

async function getDnsRecords(brandId: any) {
    const res = await apiClient.get(`/admin/brands/${brandId}/dns-records`);
    return res.data;
}

export default getDnsRecords;
